module.exports = __webpack_public_path__ + "static/media/feature_bonusrounds.ca1f81fd.jpg";